export default __webpack_public_path__ + "static/media/763.d1573f5c.gif";